module.exports = __webpack_public_path__ + "5bd43cb8b8867e4a118ea17495d4d80a.svg";